<template>
  <v-menu offset-y :disabled="disabled">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        :disabled="disabled"
        title="Enviar para o paciente preencher"
        text
        class="text-none"
        color="primary"
        v-bind="attrs"
        v-on="on"
      >
        <v-icon class="mr-2">mdi-cellphone-check</v-icon>
        Enviar para paciente
      </v-btn>
    </template>
    <v-list rounded>
      <v-list-item link @click="copyToClipboard">
        <v-icon class="mr-2">mdi-link</v-icon>
        <v-list-item-title class="item-title"> Copiar link</v-list-item-title>
      </v-list-item>
      <v-list-item link @click="openWhatsAppLink">
        <v-icon class="mr-2">mdi-whatsapp</v-icon>
        <v-list-item-title class="item-title">
          Compartilhar por WhatsApp <br />
          {{ patientMobile }}
        </v-list-item-title>
      </v-list-item>
      <v-list-item link @click="sendSms">
        <v-icon class="mr-2">mdi-message-processing-outline</v-icon>
        <v-list-item-title class="item-title">
          Enviar por SMS<br />{{ patientMobile }}
          <v-list-item-subtitle v-if="smsCooldown"
            >Aguarde {{ resendSmsSeconds }}s para poder enviar novamente
          </v-list-item-subtitle>
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>
<script>
import { createNamespacedHelpers } from 'vuex'

const { mapMutations: newAttendanceFormMutations, mapGetters: newAttendanceFormGetters } =
  createNamespacedHelpers('newAttendanceForm')

export default {
  name: 'SendAttendanceSurvey',
  props: {
    surveyType: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      surveys: {},
      smsCooldown: false,
      resendSmsSeconds: 60,
    }
  },
  computed: {
    ...newAttendanceFormGetters(['attendance', 'extraAnswers']),
    patientMobile() {
      return this.attendance.patientMobile
    },
  },
  methods: {
    ...newAttendanceFormMutations(['updateExtraAnswer']),
    async createSurveyLink() {
      try {
        this.sending = true
        let newSurvey = await this.$api.createSurveyFromAttendance(
          this.attendance.id,
          this.attendance.patient.id,
          this.attendance.physician.id,
          this.surveyType,
        )
        const uuid = newSurvey.uuid
        const extraAnswer = this.extraAnswers['survey'] ?? {}
        this.updateExtraAnswer({
          name: 'survey',
          value: {
            ...extraAnswer,
            [this.surveyType]: { uuid: uuid },
          },
        })
        return uuid
      } catch (error) {
        console.log(error)
      } finally {
        this.sending = false
      }
    },
    async copyToClipboard() {
      let surveyId = this.sentSurveys && this.sentSurveys[this.key]

      if (!surveyId) {
        surveyId = await this.createSurveyLink()
      }

      const url = `${window.location.origin}/survey/${surveyId}`
      this.$util.copyToClipboard(url)
      this.$root.ok('Link de preenchimento copiado')
    },
    async openWhatsAppLink() {
      if (!this.patientMobile) {
        return null
      }

      let surveyId = this.sentSurveys && this.sentSurveys[this.key]

      if (!surveyId) {
        surveyId = await this.createSurveyLink()
      }

      const mobileNumber = this.$util.toNumbersOnly(this.patientMobile)
      const url = `${window.location.origin}/survey/${surveyId}`
      const message = this.$util.urlEncode(`Responda o formulário em ${url}`)
      const href = `https://api.whatsapp.com/send?phone=55${mobileNumber}&text=${message}&lang=pt_br`
      window.open(href, '_blank')
    },
    async sendSms() {
      try {
        this.smsCooldown = true
        let surveyId = this.sentSurveys && this.sentSurveys[this.key]
        if (!surveyId) {
          surveyId = await this.createSurveyLink()
        }
        await this.sendSurveyLink(surveyId)
        setTimeout(() => (this.smsCooldown = false), this.resendSmsSeconds * 1000)
      } catch (error) {
        this.smsCooldown = false
        this.$root.error(error)
      }
    },
    async sendSurveyLink(surveyId) {
      const surveysToSendLink = []
      surveysToSendLink.push({
        type: this.surveyType,
        uuid: surveyId,
      })
      try {
        await this.$api.sendSurveyToPatient(surveysToSendLink, this.attendance.patient.id, this.attendance.physician.id)
        this.$root.ok('Link de preenchimento enviado para paciente')
      } catch (error) {
        console.log(error)
        this.$root.error('Não foi possível enviar os links, tente novamente mais tarde.')
      } finally {
      }
    },
  },
}
</script>
<style scoped></style>
